'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

import AblyProvider from '@/components/ably-provider';
import { useAuth } from '@/contexts/auth-context';
import { SearchParamsProvider } from '@/contexts/search-params-context';
import type { HeaderLink } from '@/types/links';

import NavBar from '../landing/NavBar';
import HeaderDashboard from './header-dashboard';

type ConditionalHeaderProps = {
  desktopLinks?: HeaderLink[];
  mobileLinks?: HeaderLink[];
};

function DynamicHeader() {
  const { user, isLoading } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || isLoading) {
    return <NavBar />;
  }

  if (user) {
    return (
      <AblyProvider>
        <SearchParamsProvider>
          <HeaderDashboard />
        </SearchParamsProvider>
      </AblyProvider>
    );
  }

  return <NavBar />;
}

export default function ConditionalHeader(props: ConditionalHeaderProps) {
  const pathname = usePathname();
  const isJoinPage = pathname.startsWith('/join');

  if (isJoinPage) {
    return null;
  }

  void props;

  return <DynamicHeader />;
}
